import { createContext, Dispatch, SetStateAction } from "react";
import { IBase_Entity } from "../services/base-services";
import { Feedback } from "../types";

export enum User_Type {
    Superadmin = "superadmin",
    Admin = "admin",
}

export interface ISuperadmin extends IBase_Entity {
    username: string;
    name: string;
    password: string;
    user_type: User_Type.Superadmin;
}

export interface IOrgadmin extends IBase_Entity {
    username: string;
    name: string;
    password: string;
    user_type: User_Type.Admin;
    organization: IBase_Entity & {
        code: string;
        name: string;
        status: "active" | "inactive";
        apiKey?: any;
    };
    branch: null;
    role: IBase_Entity & {
        id: number;
        user_type: "admin";
        type: "Admin";
        name: "Admin";
        permissions: (IBase_Entity & {
            id: number;
            op: IBase_Entity & {
                id: number;
                name: string;
                type: "Admin";
            };
        })[];
    };
}
interface UserContext {
    user: null | ISuperadmin | IOrgadmin;
    setUser: Dispatch<SetStateAction<null | ISuperadmin | IOrgadmin>>;
    permissions: string[];
    setPermissions: (newPermissions: string[]) => void;
    settings: any;
    mode: string;
    setMode: (newMode: string) => void;
    feedback: Feedback;
    setFeedback: Dispatch<SetStateAction<any>>;
    setShow: (value: boolean) => void;
    userVariant: User_Type;
    backdropLoading: boolean;
    setBackdropLoading: Dispatch<SetStateAction<boolean>>;
    store: any;
    setStore: Dispatch<SetStateAction<any>>;
    offline: boolean;
    setOffline: Dispatch<SetStateAction<boolean>>;
    showNavbar: boolean;
    setShowNavbar: Dispatch<SetStateAction<boolean>>;
}

const context = createContext<UserContext>({} as UserContext);

export default context;
